// This realm is a disposable managed view: never leave chat/account state on disk.
class VolatileStorage implements Storage {
  private values = new Map<string, string>();
  get length() { return this.values.size; }
  clear() { this.values.clear(); }
  getItem(key: string) {
    // The DOM Storage contract returns null for a missing key.
    // eslint-disable-next-line no-null/no-null
    return this.values.get(String(key)) ?? null;
  }

  key(index: number) {
    // The DOM Storage contract returns null for an out-of-range index.
    // eslint-disable-next-line no-null/no-null
    return [...this.values.keys()][index] ?? null;
  }

  removeItem(key: string) { this.values.delete(String(key)); }
  setItem(key: string, value: string) { this.values.set(String(key), String(value)); }
}

if (typeof window !== 'undefined') {
  for (const name of ['localStorage', 'sessionStorage']) {
    const storage = new VolatileStorage();
    Object.defineProperty(window, name, { configurable: false, get: () => storage });
  }
}
